import * as React from 'react'
import { CellContext } from '@tanstack/react-table'
import { User } from 'store/modules/users'
import { observer } from 'mobx-react-lite'
import { store } from 'store/index'

export const PositionCell = observer((data: CellContext<User, unknown>) => {
  const user = data.row.original
  const org_slug = store.currentUser?.org?.slug
  const hasHRIS = store.currentUser?.org?.enablePositionMapping

  if (!user.position)
    return (
      <span className="text-gray-300 whitespace-nowrap">
        {hasHRIS ? (
          <a
            href={`/orgs/${org_slug}/position-aliases`}
            className="hover:underline"
          >
            No position (set up mapping)
          </a>
        ) : (
          'No position'
        )}
      </span>
    )

  return (
    <div className="flex flex-row gap-x-3 items-center whitespace-nowrap">
      {user.position.name}
    </div>
  )
})
